import Component from './component';

Component.defaultProps = {
    onSuccess: null,
    token: null,
};
export default Component;
